import JWTDecode from 'jwt-decode';
import ACTIONS from '../actionTypes/user';
import AuthService from '../../services/AuthService';

export const getCurrentUserSession = (companyKey) => {
  return (dispatch, getState) => {
    const { company: { selectedCompany = {} } } = getState();
    return AuthService.getUserSession(selectedCompany.Key || companyKey).then((res) => {
      if (res.data) {
        dispatch({ type: ACTIONS.UPDATE_USER_CURRENT_SESSION, payload: res.data });
      }
    }).catch(() => { });
  };
};

export const clearUserInfo = () => {
  return { type: ACTIONS.CLEAR_USER_INFO };
};


export const updateUserInfoFromToken = (token) => {
  const decoded = JWTDecode(token)
  const payload = {
    Email: decoded.email,
    GlobalIdentity: decoded.sub,
    LastLogin: decoded.auth_time,
    UserName: decoded.preferred_username,
  }
  return { type: ACTIONS.UPDATE_USER_DATA_FROM_TOKEN, payload };
};

